import { Component, OnInit } from '@angular/core';
import { ColDef, ExcelExportParams, ExcelStyle, GridApi, GridReadyEvent, SizeColumnsToContentStrategy, SizeColumnsToFitGridStrategy, SizeColumnsToFitProvidedWidthStrategy } from 'ag-grid-community';
import { NgxSpinnerService } from 'ngx-spinner';
import { HrmsService } from '../hrms.service';

@Component({
  selector: 'app-costcentre-details',
  templateUrl: './costcentre-details.component.html',
  styleUrls: ['./costcentre-details.component.scss']
})
export class CostcentreDetailsComponent implements OnInit {
  private gridApi!: GridApi<any>;
  quickFilter: string = '';
  constructor(private spinner: NgxSpinnerService, private Service: HrmsService) { }
  ngOnInit(): void {
    this.hrmsCostcenter();
  }

  rowData: any[] = [];
  pinnedTopRowData: any[] = [];

  defaultExcelExportParams: ExcelExportParams = {
    exportAsExcelTable: true,
  };

  colDefs: ColDef<any>[] = [
    {
      field: 'costCenterId', headerName: 'Cost Center Id',
      minWidth: 100,
      maxWidth: 150,
      cellStyle: { 'text-align': 'right' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'costCenterName', headerName: 'Cost Center Name',
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },


  ]

  // default
  defaultColDef: ColDef = {
    flex: 1,
    sortable: true,
    filter: false,
    menuTabs: [],
    suppressHeaderMenuButton: true,
  };
  autoSizeStrategy:
    | SizeColumnsToFitGridStrategy
    | SizeColumnsToFitProvidedWidthStrategy
    | SizeColumnsToContentStrategy = {
      type: "fitCellContents",
    };

  hrmsCostcenter() {
    this.spinner.show();
    this.Service.getCostcenterdetails().subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.rowData = res;
        // console.log('res', res);
        this.spinner.hide();

      },
      error: (err: any) => {
        this.spinner.hide();
      }
    });
  }

  excelStyles: ExcelStyle[] = [
    {
      id: 'headerCell',
      font: { bold: true, size: 20 },
      alignment: { horizontal: 'Center', vertical: 'Center' },
    }
  ];

  // onBtExport() {
  //   this.gridApi.exportDataAsExcel({
  //     fileName: 'HRMS_Cost_Center_Details',
  //     sheetName: 'HRMS Costcenter Details',
  //   });
  //   alert("Execl Report genarated Please check the Download List")
  // }

  onBtExport() {
    const params: ExcelExportParams = {
      fileName: 'HRMS_Cost_Center_Details',
      sheetName: 'HRMS Costcenter Details',

      prependContent: [
        {
          cells: [
            {
              styleId: 'headerCell',
              data: {
                type: 'String',   // ← old versions use plain string
                value: 'HRMS COST CENTER DETAILS REPORT'
              },
              mergeAcross: 2
            }
          ]
        },
        {
          cells: []  // blank row
        }
      ]
    };

    this.gridApi.exportDataAsExcel(params);
    alert("Excel Report generated. Please check Downloads.");
  }

  onGridReady(params: GridReadyEvent<any>) {
    this.gridApi = params.api;
    this.gridApi.closeToolPanel();
  }

  onQuickFilterChanged(event: any) {
    this.quickFilter = event.target.value;
  }
}
